<template>
  <div class='SelectSloganModel03Theme02'>
    <input-reg
    :value="Prefes.Model03Theme02Slogan ? Prefes.Model03Theme02Slogan.text : ''"
    @update:model-value="newValue => text = newValue"
    :cont="{ textAlign: 'left', width: '70%' }"
    :label="{ marginLeft: '3px', display: 'none' }"
    :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    placeholder="Slogan"
    />
    <div class="img">
      <img v-if="img.length" :src="img" @click="$refs.in.click()">
      <img v-if="Prefes.Model03Theme02Image && !img.length" :src="api + Prefes.Model03Theme02Image.img" @click="$refs.in.click()">
      <img-icon @click="$refs.in.click()" v-if="!Prefes.Model03Theme02Image && !img.length" :options="{ width: '35px', height: '25px', color: '#CCCCCC', action: true }"/>
    </div>
    <div class="btn">
      <update-icon @click="UpdateComp"/>
    </div>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '../Produtos/Register/InputReg'
import ImgIcon from '../Icons/ImgIcon'
import UpdateIcon from '../Icons/UpdateIcon'
import api from '@/mixins/api'
import compressImage from '@/mixins/compressImage'
export default {
  name: 'SelectSloganModel03Theme02',
  components: { InputReg, ImgIcon, UpdateIcon },
  mixins: [api, compressImage],
  data () {
    return {
      text: '',
      img: '',
      filename: ''
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['UpdatePrefComp']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        this.img = await this.compressImage(reader.result)
        this.filename = file.name
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    },
    UpdateComp () {
      console.log(this.img)
      this.UpdatePrefComp({ comp: 'Model03Theme02Slogan', prop: 'text', value: this.text })
      this.UpdatePrefComp({ comp: 'Model03Theme02Image', prop: 'img', value: this.img })
    }
  }
}
</script>

<style scoped>
.SelectSloganModel03Theme02 {
  display: flex;
  padding-top: 2%;
}

.img {
  display: flex;
  justify-content: center;
  width: 20%;
}

img {
  width: 50px;
  cursor: pointer;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
}
</style>
